import React from 'react';
interface MetricCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string;
}
export function MetricCard({
  title,
  value,
  subtitle,
  icon,
  trend,
  trendValue
}: MetricCardProps) {
  // Map trend to appropriate color
  const trendColor = trend === 'up' ? 'text-emerald-400' : trend === 'down' ? 'text-rose-400' : 'text-gray-400';
  const trendIcon = trend === 'up' ? '↑' : trend === 'down' ? '↓' : '→';
  return <div className="bg-[#0F0F0F] rounded-xl shadow-[0_4px_12px_rgba(0,0,0,0.3)] p-5 flex flex-col h-full border border-[#222222] hover:border-[#333333] transition-all duration-300" data-tooltip={trendValue} data-id="element-53">
      <div className="flex items-center justify-between mb-3" data-id="element-54">
        <h3 className="text-sm font-medium text-gray-400" data-id="element-55">{title}</h3>
        {icon && <div className="text-white" data-id="element-56">{icon}</div>}
      </div>
      <div className="flex items-baseline" data-id="element-57">
        <p className="text-2xl font-semibold text-white" data-id="element-58">{value}</p>
        {subtitle && <p className="ml-2 text-xs text-gray-400" data-id="element-59">{subtitle}</p>}
      </div>
      {trend && <div className={`mt-3 flex items-center text-xs font-medium ${trendColor}`} data-id="element-60">
          <span className="mr-1" data-id="element-61">{trendIcon}</span>
          <span data-id="element-62">{trendValue}</span>
        </div>}
    </div>;
}